const InterfaceConstructor = require("../template")
const cookieUtils = require("../../utils/cookie")
const storage = new InterfaceConstructor("storage")

storage.methods = {
    // Cookie Methods
    getCookie: (data = {}) => {
        return cookieUtils.getCookie(data.key)
    },
    setCookie: (data = {}) => {
        cookieUtils.setCookie(data.key, data.value, data.duration)
    },
    deleteCookie: (data = {}) => {
        cookieUtils.deleteCookie(data.key)
    },
    clearCookies: () => {
        cookieUtils.clearCookies()
    },
    // Local Storage Methods
    getLocalStorageItem: (data = {}) => {
        return localStorage.getItem(data.key)
    },
    setLocalStorageItem: (data = {}) => {
        localStorage.setItem(data.key, data.value)
    },
    deleteLocalStorageItem: (data = {}) => {
        localStorage.removeItem(data.key)
    },
    clearLocalStorage: () => {
        localStorage.clear()
    },
    // Session Storage Methods
    getSessionStorageItem: (data = {}) => {
        return sessionStorage.getItem(data.key)
    },
    setSessionStorageItem: (data = {}) => {
        sessionStorage.setItem(data.key, data.value)
    },
    deleteSessionStorageItem: (data = {}) => {
        sessionStorage.removeItem(data.key)
    },
    clearSessionStorage: () => {
        sessionStorage.clear()
    },
}

module.exports = storage
